import { Component, OnInit } from '@angular/core';
import { Globals } from '../../services/globals';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { VideoComponent } from '../video/video.component';
import { TutorialVideo } from '../../engine/models/models';

@Component({
  selector: 'app-video-library',
  templateUrl: './video-library.component.html',
  styleUrls: ['./video-library.component.css']
})
export class VideoLibraryComponent implements OnInit {

  public tutorialVideos: TutorialVideo[];

  constructor(public globals: Globals,
    public dialog: MatDialog,) {
    if (this.globals.tutorialVideos) {

    } else {
      this.globals.getTutorialVideos();
    }
  }

  get loading() {
    this.tutorialVideos = this.globals.tutorialVideos;
    return !this.tutorialVideos;
  }

  formatUrl(relativeUrl: string) {
    // If the URL is null, simply return it.
    if (!relativeUrl) { return relativeUrl; }
    return `${relativeUrl}`;
  }

  openVideoDialog(video: TutorialVideo) {
    video.disableClose = false;
    this.globals.selectedVideo = video;
    //set height for video player
    localStorage.setItem('windowHeigth', (window.innerHeight - 60).toString())
    const videoDialog = this.dialog.open(VideoComponent, { minWidth: '98%', disableClose: true });
    videoDialog.afterClosed().subscribe(result => { return; });
  }
  ngOnInit(): void {

  }
}
